module.exports = __webpack_public_path__ + "static/analytics-27a5ce2c0f2b031f0654a34d22e739d6.png";